import CardSeplag from "../../components/CardSeplag";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import RotuloSeplag from "../../components/RotuloSeplag";
import { SelectButton } from "primereact/selectbutton";
import { Panel } from "primereact/panel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { useSelector } from "react-redux";

const PerfilUsuario = () => {
  const optSexo = [
    { name: "Feminino", value: "F" },
    { name: "Masculino", value: "M" },
  ];
  const user = useSelector((state) => state.userReducer.user);

  function titleCard() {
    let titulo = "Bem vindo(a) " + user.contaAcesso.pessoa.nomePessoa;
    return <span>{titulo}</span>;
  }

  const columnDescPerfilAcessoTemplate = (node, column) => {
    let descPerfilAcesso = "";
    descPerfilAcesso =
      node.perfilAcesso.autorizacoes[0] && node.perfilAcesso.autorizacoes[0].data.nomeExibir
        ? node.perfilAcesso.autorizacoes[0].data.nomeExibir
        : "";
    return (
      <span>
        <p>{descPerfilAcesso}</p>
      </span>
    );
  };

  return (
    <>
      <CardSeplag title={titleCard()}>
        <Panel header="IDENTIFICAÇÃO">
          <div className="grid line-height-4 col-12">
            <div className="field col-12 md:col-8 ">
              <RotuloSeplag nome="Nome" obrigatorio={true}>
                <InputText
                  type="text"
                  value={user.contaAcesso.pessoa.nomePessoa}
                  id="pessoa.nomePessoa"
                  name="pessoa.nomePessoa"
                  placeholder="Nome"
                  disabled={true}
                />
              </RotuloSeplag>
            </div>
            <div className="col-12 md:col-4 ">
              <RotuloSeplag nome="Sexo" cols="12" obrigatorio={true}>
                <div className="field">
                  <SelectButton
                    optionLabel="name"
                    style={{ padding: "0.1rem " }}
                    value={user.contaAcesso.pessoa.flagSexo}
                    options={optSexo}
                    id="pessoa.flagSexo"
                    name="pessoa.flagSexo"
                    disabled={true}
                  />
                </div>
              </RotuloSeplag>
            </div>
            <div className="field col-12 md:col-4 ">
              <RotuloSeplag nome="Login" obrigatorio={true}>
                <InputText
                  type="text"
                  value={user.contaAcesso.login}
                  id="login"
                  name="login"
                  placeholder="Login"
                  disabled={true}
                />
              </RotuloSeplag>
            </div>
            <div className="field col-12 md:col-4 ">
              <RotuloSeplag nome="CPF" obrigatorio={true}>
                <InputMask
                  value={user.contaAcesso.pessoa.numrCpf}
                  id="pessoa.numrCpf"
                  name="pessoa.numrCpf"
                  mask="999.999.999-99"
                  placeholder="999.999.999-99"
                  disabled={true}
                />
              </RotuloSeplag>
            </div>
            <div className="field col-12 md:col-4 ">
              <RotuloSeplag nome="Email" obrigatorio={true}>
                <InputText
                  type="text"
                  value={user.contaAcesso.pessoa.descEmail}
                  id="pessoa.descEmail"
                  name="pessoa.descEmail"
                  placeholder="Email"
                  disabled={true}
                />
              </RotuloSeplag>
            </div>

            <div className="field col-12 md:col-4 ">
              <RotuloSeplag nome="Data de Nascimento" cols="12 6" obrigatorio={true}>
                <InputText
                  type="text"
                  value={user.contaAcesso.pessoa.dataNascimento}
                  id="pessoa.dataNascimento"
                  name="pessoa.dataNascimento"
                  placeholder="99/99/9999"
                  mask="99/99/9999"
                  disabled={true}
                />
              </RotuloSeplag>
            </div>

            <div className="field col-12 md:col-4 ">
              <RotuloSeplag nome="Telefone Pessoal" cols="12 6" obrigatorio={true}>
                <InputMask
                  value={user.contaAcesso.pessoa.numrTelefoneCelular}
                  id="pessoa.numrTelefoneCelular"
                  name="pessoa.numrTelefoneCelular"
                  mask="(99)99999999"
                  placeholder="(99)99999-9999"
                  disabled={true}
                />
              </RotuloSeplag>
            </div>
            <div className="field col-12 md:col-4 ">
              <RotuloSeplag nome="Telefone Celular" cols="12 6" obrigatorio={true}>
                <InputMask
                  value={user.contaAcesso.pessoa.numrTelefonePessoal}
                  id="pessoa.numrTelefonePessoal"
                  name="pessoa.numrTelefonePessoal"
                  mask="(99)99999999?9"
                  placeholder="(99)99999-9999"
                  disabled={true}
                />
              </RotuloSeplag>
            </div>
          </div>
        </Panel>
        <br />
        <Panel header="PERFIL DE ACESSO">
          <DataTable
            value={user.contaAcesso.perfis}
            responsiveLayout="scroll"
            dataKey="idenPerfilVinculo"
            emptyMessage="Dados não encontrados"
          >
            <Column field="vinculo.numrVinculo" header="Nº"></Column>
            <Column field="vinculo.orgao.descOrgao" header="Órgão"></Column>
            <Column field="vinculo.tipoVinculo.descTipoVinculo" header="Tipo Vínculo"></Column>
            <Column field="perfilAcesso.nomePerfilAcesso" header="Nome do Perfil"></Column>
            <Column
              body={columnDescPerfilAcessoTemplate}
              field="perfilAcesso.autorizacoes"
              header="Descrição do Perfil"
            ></Column>
          </DataTable>
        </Panel>
      </CardSeplag>
    </>
  );
};

export default PerfilUsuario;
